export const DeleteAccountModal = ({closeModal, popupTitle, popupText, popupSubmit, popupCancel}) => {
  return (
    <div className="delete-account__modal-wrapper">
      <h3 className="delete-account__modal-header">{popupTitle}</h3>

      <p className="delete-account__modal-text">{popupText}</p>

      <div className="delete-account__buttons-wrapper">
        <button className="delete-account__submit-button" onClick={closeModal}>{popupCancel}</button>

        <button
          className="delete-account__submit-button delete-account__submit-button--dark"
          onClick={() => {
            closeModal();
            document.getElementById("delete-account__submit-button").parentElement.submit();
          }}
        >
          {popupSubmit}
        </button>
      </div>
    </div>
  )
}